import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { NewButton, Icon, Text } from '../../../../../components';

const ChatCannedAnswerContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 20px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
`;

const StyledText = styled(Text)`
  margin-bottom: 20px;
`;

const ChatCannedAnswer = ({
  category,
  handleOpenSourceTab,
  handleOpenDataDictionary,
  handleAddChart,
  handleRetry,
  handleRemoveQuestion,
  handleHelpClick
}) => {
  const getButtonSets = () => {
    switch (category) {
      case 'B':
        return [
          { text: 'Open source tab', icon: 'cylinder', onClick: handleOpenSourceTab },
          { text: 'Ask anyway', icon: 'arrow-up', onClick: handleRetry }
        ];
      case 'C':
        return [
          { text: 'How to use supper', icon: 'help-circle', onClick: handleHelpClick },
          { text: 'Ask anyway', icon: 'arrow-up', onClick: handleRetry }
        ];

      case 'D':
        return [
          { text: 'Open data dictionary', icon: 'book', onClick: handleOpenDataDictionary },
          { text: 'Ask anyway', icon: 'arrow-up', onClick: handleRetry }
        ];

      case 'E':
        return [{ text: 'Add chart', icon: 'plus', onClick: handleAddChart }];

      case 'F':
      default:
        return [
          { text: 'Retry', icon: 'refresh', onClick: (e) => handleRetry(e) },
          { text: 'Remove question', icon: 'trash', onClick: (e) => handleRemoveQuestion(e) }
        ];
    }
  };

  const buttonSets = getButtonSets();

  return (
    <ChatCannedAnswerContainer>
      {['B', 'C', 'D'].includes(category) && (
        <StyledText>
          Or, &quot;ask anyway&quot; if you&apos;re trying to ask a data question.
        </StyledText>
      )}
      <ButtonGroup>
        {buttonSets.map((button, index) => (
          <NewButton key={index} onClick={button.onClick}>
            <Icon name={button.icon} displaySize={20} />
            {button.text}
          </NewButton>
        ))}
      </ButtonGroup>
    </ChatCannedAnswerContainer>
  );
};

ChatCannedAnswer.propTypes = {
  category: PropTypes.oneOf(['B', 'C', 'D', 'E', 'F']),
  handleOpenSourceTab: PropTypes.func,
  handleOpenDataDictionary: PropTypes.func,
  handleAddChart: PropTypes.func,
  handleRetry: PropTypes.func,
  handleRemoveQuestion: PropTypes.func,
  handleHelpClick: PropTypes.func
};

export { ChatCannedAnswer };
